/**
 * Route table. One place that knows every path in the app, so the top nav, the
 * mobile tab bar and the PLAY hub tiles cannot drift apart from the router.
 */

import type { UiIconName } from '@/ui/icons/UiIcon';

export const ROUTES = {
  play: '/play',
  playBot: '/play/bot',
  playLab: '/play/lab',
  playDeckTest: '/play/deck-test',
  playTutorial: '/play/tutorial',
  collection: '/collection',
  store: '/store',
  profile: '/profile',
  help: '/help',
} as const;

export type RouteKey = keyof typeof ROUTES;

export interface NavItem {
  key: RouteKey;
  label: string;
  path: string;
  icon: UiIconName;
}

/** The five top-level destinations. UI_UX section 6. */
export const NAV_ITEMS: NavItem[] = [
  { key: 'play', label: 'Play', path: ROUTES.play, icon: 'play' },
  { key: 'collection', label: 'Collection', path: ROUTES.collection, icon: 'collection' },
  { key: 'store', label: 'Store', path: ROUTES.store, icon: 'store' },
  { key: 'profile', label: 'Profile', path: ROUTES.profile, icon: 'profile' },
  { key: 'help', label: 'Help', path: ROUTES.help, icon: 'help' },
];
